import { LOCATION_META, tint } from '../../constants';
import { DateNav } from '../DateNav/DateNav';
import s from '../../styles/dashboard.module.css';

const money = (cents) => {
  const n = (cents || 0) / 100;
  // Whole dollars read better at a glance; cents only when they matter.
  return n % 1 === 0
    ? `$${n.toLocaleString('en-US')}`
    : `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

// One figure with a label above and a quiet note beside it.
function StatTile({ label, value, note, tone }) {
  return (
    <div className={s.statTile}>
      <div className={s.statTileLabel}>{label}</div>
      <div className={s.statTileRow}>
        <span className={`${s.statTileValue} ${tone ? s[tone] : ''}`}>{value}</span>
        {note && <span className={s.statTileNote}>{note}</span>}
      </div>
    </div>
  );
}

// Summary bar under the header: date nav, the day's money, location filters.
export function StatsBar({ selectedDate, onChangeDate, totals, activeLocations, toggleLocation, isToday }) {
  const t = totals;
  const receivableNote = t.receivableKinds.length
    ? t.receivableKinds.join(' + ')
    : 'none outstanding';

  return (
    <div className={s.statsBar} style={{ flexShrink: 0 }}>
      <DateNav selectedDate={selectedDate} onChange={onChangeDate} />
      <div className={s.statsBarDivider} />

      <StatTile label="Cars today"  value={t.cars} note={`${t.finished} finished`} />
      <StatTile label="Collected"   value={money(t.collectedCents)} tone="green"
                note={`${plural(t.collectedCars, 'car')}, excludes tax and tip`} />
      <StatTile label="Receivables" value={money(t.receivablesCents)} tone="blue"
                note={receivableNote} />
      <StatTile label="Payment due" value={money(t.dueCents)} tone="red"
                note={plural(t.dueCars, 'car')} />
      <StatTile label="Tips earned" value={money(t.tipsCents)} tone="green" note="locked at finish" />

      {/* Location filters keep working; the count moved into the tiles above. */}
      {/* <div className={s.statsLocations}>
        {Object.entries(LOCATION_META).map(([locId, meta]) => {
          const isActive = activeLocations.includes(locId);
          return (
            <button key={locId} onClick={() => toggleLocation(locId)}
              className={`${s.locChip} ${isActive ? s.active : ''}`}
              style={isActive ? { color: meta.color, borderColor: tint(meta.color, 40) } : undefined}
              title={isActive ? `Hide ${meta.name}` : `Show ${meta.name}`}>
              {meta.name}
            </button>
          );
        })}
      </div> */}

      <span className={s.liveTag}>{isToday ? '● LIVE FROM SQUARE' : '○ HISTORICAL VIEW'}</span>
    </div>
  );
}
